import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import { isExistInComparisonList } from '@/utils/object';
import {
  addToCompare,
  updateComparisonCategory,
  updateComparisonPopupState,
  updateIsMinimizeCompareActionState,
  updateIsOpenCannotBeAddedModalState,
  updateIsOpenCompareBottomActionState,
} from '@/redux/reducers/product-comparison-reducer';
import { comparisonPopupMessages } from '@/constants/message';
import { pageTypes } from '@/constants/types';
import { useRouter } from 'next/navigation';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function CompareButton({
  label,
  className,
  hideIcon = false,
  productData,
  categoryData,
  pageType = pageTypes.categoricalProduct,
  redirectionUrl = '',
}) {
  const router = useRouter();
  const dispatch = useDispatch();

  const { lang } = useSelector((state) => state.globalSettings);
  const { comparingProducts, comparisonCategory } = useSelector(
    (state) => state.productComparison,
  );

  const handleCompare = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const comparisonProductData = {
      id: productData?.id,
      name: productData?.name,
      slug: productData?.slug ?? null,
      images: productData?.images?.thumbnail ?? [],
      parentSlug: productData?.parentSlug ?? null,
      parentId: productData?.parent_id ?? null,
    };

    if (comparingProducts?.length === 0) {
      dispatch(
        updateComparisonCategory({ category: categoryData.slug, mode: true }),
      );

      dispatch(addToCompare(comparisonProductData));
      dispatch(updateIsOpenCompareBottomActionState(true));

      setTimeout(() => {
        dispatch(
          updateComparisonPopupState({
            isSuccess: true,
            message: `${comparisonProductData?.name[lang]} is added to the comparison
                  list`,
            isShow: true,
          }),
        );
      }, 500);
    } else if (comparingProducts?.length > 0 && comparingProducts?.length < 3) {
      if (categoryData.slug === comparisonCategory) {
        dispatch(addToCompare(comparisonProductData));
        dispatch(updateIsMinimizeCompareActionState(false));

        dispatch(
          updateComparisonPopupState({
            isSuccess: true,
            message: `${comparisonProductData?.name[lang]} is added to the comparison
                list`,
            isShow: true,
          }),
        );
      } else {
        dispatch(
          updateIsOpenCannotBeAddedModalState({
            status: true,
            data: comparisonProductData?.name[lang],
          }),
        );
      }
    } else if (comparingProducts?.length >= 3) {
      if (categoryData?.slug === comparisonCategory) {
        dispatch(
          updateComparisonPopupState({
            isSuccess: false,
            message: comparisonPopupMessages.removedList,
            isShow: true,
          }),
        );
      } else {
        dispatch(
          updateIsOpenCannotBeAddedModalState({
            status: true,
            data: comparisonProductData?.name[lang],
          }),
        );
      }
      return null;
    }
    return null;
  };

  return (
    <button
      type="button"
      aria-label="compare button"
      className={cn(
        'w-[124px] lg:w-[200px] h-[24px] lg:h-[36px] rounded-[100px] flex justify-center items-center gap-[6px] bg-white text-pacific-queen px-16 border border-pacific-queen hover:bg-placebo-green',
        className,
        {
          'hover:bg-transparent bg-transparent': isExistInComparisonList(
            comparingProducts,
            productData?.id,
          ),
        },
      )}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (pageType === pageTypes.other) {
          router.push(redirectionUrl);

          setTimeout(() => {
            if (!isExistInComparisonList(comparingProducts, productData?.id)) {
              handleCompare(e);
            }
          }, 800);
          return null;
        }

        if (!isExistInComparisonList(comparingProducts, productData?.id)) {
          handleCompare(e);
        }
      }}
    >
      {!hideIcon ? (
        <Icon
          type="compare"
          className="size-[16px] lg:size-[24px] inline-block"
        />
      ) : null}

      <ButtonLabel
        label={label}
        className={cn(
          'text-xs lg:text-sm font-semibold lg:font-bold text-center text-pacific-queen',
        )}
      />
    </button>
  );
}

export default CompareButton;
